import type { CreateContractorRequest } from '@omnipresentgroup/types';

import type { AddContractorFields } from './types';

export const mapAddContractorFieldsToCreateContractorRequest = (
  values: AddContractorFields,
): CreateContractorRequest => {
  const { contractorDetails, contractualAgreement, billingArrangements } =
    values.contractor;
  const {
    misclassificationRiskAccepted,
    misClassificationAssessmentCode,
    contractTemplateUsageAccepted,
  } = values.liabilityShield;

  const {
    contractorsFirstName,
    contractorsLastName,
    contractorsEmail,
    contractorsRole,
    contractorsCountry,
  } = contractorDetails;

  const {
    invoicingAmount,
    contractualAgreementFrequency,
    contractualAgreementDateRange,
  } = contractualAgreement;

  const { billingArrangementsCurrency } = billingArrangements;

  return {
    firstName: contractorsFirstName,
    lastName: contractorsLastName,
    email: contractorsEmail,
    jobRole: contractorsRole,
    residenceCountry: contractorsCountry,
    invoicingCurrency: invoicingAmount.currency,
    billingCurrency: billingArrangementsCurrency,
    expectedInvoicingFrequency: contractualAgreementFrequency,
    invoiceAmount: invoicingAmount.amount?.toString(),
    startDate: contractualAgreementDateRange?.contractualAgreementStartDate,
    endDate: contractualAgreementDateRange?.contractualAgreementEndDate,
    misclassificationRiskAccepted: misclassificationRiskAccepted,
    misclassificationAssessmentCode: misClassificationAssessmentCode,
    contractTemplateUsageAccepted: contractTemplateUsageAccepted,
  };
};
